import { MutableRefObject, useEffect, useRef } from "react";

export const useOutsideClick = (
  cb: () => void,
  buttonRef?: MutableRefObject<HTMLButtonElement | null>
) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        (!buttonRef || !buttonRef.current?.contains(event.target as Node))
      ) {
        cb();
      }
    };

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [cb, buttonRef]);

  return ref;
};
